import { render } from "./StepperHeading.vue?vue&type=template&id=3a9d97b2&scoped=true"
import script from "./StepperHeading.vue?vue&type=script&lang=js"
export * from "./StepperHeading.vue?vue&type=script&lang=js"

import "./StepperHeading.vue?vue&type=style&index=0&id=3a9d97b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a9d97b2"]])

export default __exports__